import React from 'react';
import { TariffModule } from "../../../../../../store/blocks/tariffs/tariffSelectors";
export var TariffModuleProvider = function TariffModuleProvider(_ref) {
  var children = _ref.children,
    data = _ref.data;
  return /*#__PURE__*/React.createElement(TariffModule, {
    selectTariff: function selectTariff() {
      return data;
    },
    "data-t-id": "common-TariffModuleProvider"
  }, children);
};